import { Pipe, PipeTransform } from '@angular/core';

const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const FILE_SIZE_UNITS_LONG = [
  'Bytes',
  'Kilobytes',
  'Megabytes',
  'Gigabytes',
  'Pettabytes',
  'Exabytes',
  'Zettabytes',
  'Yottabytes',
];

@Pipe({
  name: 'formatFileSize',
})
export class FormatFileSizePipe implements PipeTransform {
  power: any;
  transform(sizeInBytes: number, longForm: boolean): string {
    const units = longForm ? FILE_SIZE_UNITS : FILE_SIZE_UNITS_LONG;

    if (sizeInBytes == 0) {
      this.power = 0;
    } else {
      this.power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
      this.power = Math.min(this.power, units.length - 1);
    }

    const size = sizeInBytes / Math.pow(1024, this.power); // size in new units
    const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
    const unit = units[this.power];

    return `${formattedSize} ${unit}`;
  }
}
